var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('img',{staticClass:"app-media-img",class:_vm.cssClass,attrs:{"src":_vm.imageUrl,"alt":_vm.altText,"title":_vm.altText}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }